import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import EditOutlined from '@ant-design/icons/lib/icons/EditOutlined'
import { baseAxiosComplete, baseAxiosNoInfo } from '../../../tool/axios'
import moment from 'moment'

const { Option } = Select

interface baby {
    id: string
    nick_name: string
    sex: number
    born_date: string
    height: number
    weight: number
    jaundice_value: string
    reserve_list: {
        check_in_id: string // 入住id，“入住客户管理-按条件查询列表（分页）”接口返回的check_in_id字段
        service_type_id: number // 服务类型，1满月派对
        reserve_date: string // 预约日期
    }[]
}

const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 }
}

interface Prop {
    status: any,
    storeID?: string
    onFinish?: () => void
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [data, setData] = useState<baby[]>([])
    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()
    const [activeID, setActiveID] = useState<string>()

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/baby_list', {
            params: {
                check_in_id: param.id
            }

        }).then((res: any) => {
            res && setData(res)
        })
    }

    const changeClientInfo = (values: any) => {
        if (!activeID) {
            baseAxiosComplete.post('/keeper/check_in/detail/add_baby_info', {
                check_in_id: param.id,
                nick_name: values.nick_name,
                sex: values.sex,
                born_date: values.born_date.format('YYYY-MM-DD'),
                height: values.height,
                weight: values.weight

            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                    getClientInfo()
                }
            })

        } else {
            baseAxiosComplete.post('/keeper/check_in/detail/update_baby_info', {
                check_in_id: param.id,
                id: activeID,
                nick_name: values.nick_name,
                sex: values.sex,
                born_date: values.born_date.format('YYYY-MM-DD'),
                height: values.height,
                weight: values.weight

            }).then(res => {
                if (res.status === 0) {
                    setVisible(false)
                    getClientInfo()
                }
            })
        }
    }

    useEffect(() => {
        getClientInfo()
    }, [])

    return (<div className="modules" style={{ marginBottom: 40 }}>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 新增或编辑客户信息 */}
        <Modal title={!activeID ? "新增宝宝信息" : "编辑宝宝信息"} visible={visible} onCancel={() => { setVisible(false) }} footer={false}>
            <Form  {...formItemLayout} form={form} onFinish={changeClientInfo} >
                <Form.Item label="宝宝昵称" name="nick_name">
                    <Input />
                </Form.Item>
                <Form.Item label="宝宝性别" name="sex" rules={[{ required: true, message: '必须选择宝宝性别' }]}>
                    <Select>
                        <Option value={0} key={0}>男</Option>
                        <Option value={1} key={1}>女</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="宝宝生日" name="born_date" rules={[{ required: true, message: '必须选择宝宝生日' }]}>
                    <DatePicker />
                </Form.Item>
                <Form.Item label="宝宝身高(cm)" name="height" >
                    <Input />
                </Form.Item>
                <Form.Item label="体重(kg)" name="weight" >
                    <Input />
                </Form.Item>
                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        <div className="top clear">
            <h3 className="fl">
                <span className="fl">宝宝信息</span>
                {
                    prop.status != '客户退单' ? (
                        <Button type="primary"
                            onClick={() => {
                                setActiveID(undefined)
                                form.setFieldsValue({
                                    nick_name: undefined,
                                    sex: undefined,
                                    born_date: undefined,
                                    height: undefined,
                                    weight: undefined
                                })
                                setVisible(true)
                            }}
                            size="small" style={{ marginLeft: 10, fontSize: 12 }}>
                            新增宝宝信息
                        </Button>
                    ) : null
                }
            </h3>
        </div>

        {data.map(el => <div className="clear" style={{ marginBottom: 16 }}>
            {
                prop.status != '客户退单' ? (
                    <div className="fr editbtn" onClick={() => {
                        setActiveID(el.id)
                        form.setFieldsValue({
                            nick_name: el?.nick_name,
                            sex: el?.sex,
                            born_date: moment(el?.born_date),
                            height: el?.height,
                            weight: el?.weight
                        })
                        setVisible(true)
                    }}><EditOutlined style={{ marginRight: 10, marginBottom: 12 }} />编辑宝宝信息</div>
                ) : null
            }

            {/* 管家中心 -> 入住管理 -> 客户详情 -> 宝宝信息 */}
            <Row style={{ width: '100%', marginTop: 15 }}>
                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">昵称：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.nick_name || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">性别：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.sex === 0 ? '男' : '女'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">生日：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.born_date || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">身高：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.height + '(cm)' || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">体重：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.weight + '(kg)' || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={4}>
                    <div>
                        <Space wrap>
                            <p className="label">黄疸值：</p>
                            <p className='right-text' style={{ width: '150px' }}>{el?.jaundice_value + '(mg/dl)' || '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            {/* 管家中心 -> 入住管理 -> 客户详情 -> 宝宝信息 -> 预约服务 */}
            {el.reserve_list && el?.reserve_list.map(el2 => <Row style={{ width: '100%', marginTop: 10 }}>
                <Col span={5}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ color: 'red' }}>服务类型：</p>
                            <p className='right-text' style={{ width: '150px', color: 'red' }}>{el2?.service_type_id === 1 && '满月派对' || el2?.service_type_id === 2 && '剃胎发' || el2?.service_type_id === 3 && '宝宝摄影'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={5}>
                    <div>
                        <Space wrap>
                            <p className='label' style={{ color: 'red' }}>预约日期：</p>
                            <p className='right-text' style={{ width: '150px', color: 'red' }}>{el2?.reserve_date}</p>
                        </Space>
                    </div>
                </Col>
            </Row>)}
        </div>)}
    </div>)
}